module.exports =
  '_ERROR_HANDLER':
    'UNEXPECTED_ERROR_MSG': 'Something bad heppened. Sorry for your inconvenie. We are appreciate your patience.'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/error-handler/i18n/en.coffee